export default __webpack_public_path__ + "static/media/Vikendica 2.52692461.jpeg";